<template>
  <div class="flexslider">
    <ul class="slides">
      <li v-for="(image, index) in currentImages" :key="index">
        <img :src="getImagePath(image)" :alt="'Slide ' + (index + 1)" />
      </li>
    </ul>
  </div>
</template>

<script>
import $ from "jquery";
import "flexslider";
import "flexslider/flexslider.css";

export default {
  data() {
    return {
      images: [
        "Babilonia26.jpg",
        "los_descreidos_muerte_1.jpeg",
        "Grupo_Scaled.JPG",
        "Yuri_Playa.JPG",
        "Babilonia_Circo_1.jpeg",
        "Circo_Scaled.jpg"
      ],
      isMobile: false
    };
  },
  computed: {
    currentImages() {
      if (!this.isMobile) {
        return this.images;
      }
      // Return mobile versions
      return this.images.map(img => {
        const lastDot = img.lastIndexOf('.');
        const name = img.substring(0, lastDot);
        const ext = img.substring(lastDot);
        return `${name}_mobile${ext}`;
      });
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);

    this.$nextTick(() => {
      $(".flexslider").flexslider({
        animation: "slide",
        slideshow: true,
        slideshowSpeed: 2500,
        animationSpeed: 600,
        animationLoop: true,
        itemWidth: "100%",
        itemMargin: 0,
        minItems: 1,
        maxItems: 1,
        controlNav: true,
        directionNav: false
      });
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    getImagePath(img) {
      const name = typeof img === "string" ? img : (img && img.src) || "";
      return `/images/${String(name).replace(/['"]/g, "")}`;
    }
  }
};
</script>

<style scoped>
.flexslider {
  margin: 0;
  padding: 0;
  box-shadow: none;
  border-radius: 0;
  border: 0;
  position: relative;
  background: transparent !important; /* remove default white */
}

/* Dark gradient overlay for nav visibility */
.flexslider::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 250px;
  background: linear-gradient(to bottom, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.6) 40%, rgba(0,0,0,0.2) 70%, transparent 100%);
  z-index: 10;
  pointer-events: none;
}
.flexslider .slides { background: transparent !important; }
.slides img { width: 100%; height: auto; }

/* Dots on the right (desktop, unchanged) */
:deep(.flex-control-nav.flex-control-paging) {
  width: 20px;
  bottom: auto;
  top: 50%;
  right: 20px;
  z-index: 20;
}

/* Dot styles */
:deep(.flex-control-nav li a) {
  width: 12px;
  height: 12px;
  background: #ccc;
  border-radius: 50%;
  display: block;
  transition: background 0.3s;
}
:deep(.flex-control-nav li a.flex-active) { background: #fff; }
:deep(.flex-control-nav li a:hover) { background: white; }

/* MOBILE: make slider tall and full-bleed */
@media (max-width: 768px){
  .flexslider,
  .flexslider .slides,
  .flexslider .slides li{
    height: 55vh;
  }
  .slides img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  /* Hide navigation dots on mobile */
  :deep(.flex-control-nav.flex-control-paging) { display: none; }
}
</style>